export default __webpack_public_path__ + "static/media/6.Little_Mermaid.1556a0bb.wav";